import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { Browser } from "@capacitor/browser";
import { useAuth0 } from "@auth0/auth0-react";
import { trackSignupScreenSeenAt } from "src/utils/analyticsCapFirebase";

interface UpgradeSubscriptionNonLoggedProps {
    setIsPaymentOpen?: (open: boolean) => void;
    setInitialPaymentView?: (view: string) => void;
}

const UpgradeSubscriptionNonLogged: React.FC<UpgradeSubscriptionNonLoggedProps> = ({ setIsPaymentOpen, setInitialPaymentView }) => {
    const { loginWithRedirect } = useAuth0();

    // Function to handle the login - replicates GetStartedPage login flow
    const handleSignUpForFree = async (event: React.MouseEvent) => {
        // Stop the event propagation
        event.stopPropagation();

        // Login with redirect - exact same logic as GetStartedPage
        await trackSignupScreenSeenAt("locked_feature", "upgrade_non_logged");
        await loginWithRedirect({
            async openUrl(url) {
                // Redirect using Capacitor's Browser plugin
                await Browser.open({
                    url,
                    windowName: "_self",
                });
            },
        });
    };

    return (
        <Box
            sx={{
                width: "95%",
                bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}`,
                borderRadius: 2,
                border: `1px solid ${PureLightThemeCaaS.colors.alpha.orange[70]}`,
                p: 1,
                mb: 1,
                mx: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
            }}
        >
            {/* Text content */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    //   gap: 0.5,
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                        fontSize: "14px",
                        textAlign: "center",
                        lineHeight: 1.2,
                    }}
                >
                    Want to give premium a try?
                </Typography>
            </Box>

            {/* Sign Up For Free button */}
            <Button
                variant="contained"
                onClick={handleSignUpForFree}
                sx={{
                    width: "50%",
                    bgcolor: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
                    color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                    borderRadius: 2,
                    px: 2,
                    py: 0,
                    textTransform: "none",
                    fontSize: "15px",
                    fontWeight: "bold",
                    "&:hover": {
                        bgcolor: `${PureLightThemeCaaS.colors.alpha.orange[70]}`,
                    },
                }}
            >
                Sign Up For Free
            </Button>
        </Box>
    );
};

export default UpgradeSubscriptionNonLogged;
